var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvironmentalistIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0407 2.40039C6.9311 2.40039 3.59961 5.73188 3.59961 9.84149C3.59961 12.0729 4.58179 14.0749 6.13742 15.4387C6.27664 15.5608 6.36125 15.7349 6.36125 15.9201V18.2629C6.36125 18.5063 6.50509 18.7267 6.72789 18.8246L12.8265 21.5068C13.2321 21.6851 13.6873 21.3881 13.6873 20.945V18.7018C13.6873 18.3628 13.962 18.0881 14.301 18.0881H17.6763C18.0153 18.0881 18.29 17.8133 18.29 17.4744V15.5432C18.29 15.3155 18.4161 15.1065 18.6175 15.0003L19.874 14.3378C20.167 14.1833 20.2845 13.8242 20.1396 13.5264L18.544 10.2475C18.5 10.1572 18.4794 10.0575 18.4809 9.95713C18.4815 9.91865 18.4818 9.8801 18.4818 9.84149C18.4818 5.73188 15.1503 2.40039 11.0407 2.40039Z",
    stroke: "#47AD1D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.47256 11.7289C6.89345 8.64444 9.44504 6.23928 13.5528 7.22344C13.8425 7.29285 14.0417 7.55888 14.0272 7.85641C13.8998 10.4775 12.7052 11.9629 9.03878 12.0574C8.80258 12.0635 8.58023 11.9392 8.47256 11.7289Z",
    stroke: "#47AD1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32031 13.0706C8.82481 11.2208 8.99295 10.2119 11.0108 9.37109",
    stroke: "#47AD1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvironmentalistIcon);
export default __webpack_public_path__ + "static/media/environmentalistIcon.1efe9746d93c70db629a3c41249d963e.svg";
export { ForwardRef as ReactComponent };